import { Paragraph } from '@zillow/constellation';
import styled from 'styled-components';

export const HomeLoansDashboardLinkParagraph = styled(Paragraph)`
    font-size: 14px;
`;
